import { render, staticRenderFns } from "./AddColAfterIcon.vue?vue&type=template&id=0c72edc2"
import script from "./AddColAfterIcon.vue?vue&type=script&lang=js"
export * from "./AddColAfterIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports